import BuyChallengeBar from "../components/BuyChallengeBar"
import Evaluation from "../components/Evaluation"
import Layout from "../components/layout"
import Quote from "../components/Quote"
import React from "react"
import SEO from "../components/seo"
import TwoSteps from "../components/TwoSteps"
import Helmet  from "react-helmet"
import community from "../images/empowered-community.jpg"
import grant from "../images/grant-headshot.jpg"
import styles from "../styles/challenges.module.scss"
import toni from "../images/toni-headshot.jpg"

//Static Home Page
const challengesPage = () => (
  <Layout>
     <Helmet>
       <title>Challenges | em•power with Shawna | Check out our Programs!</title>
       <meta name="title" content="Challenges" />
            <meta name="description" content="Check out our programs including the Power Program and the Full Power Program that includes a personalized 7-Week Challenge based on your ethos manifest!" />   
             </Helmet>
    <section className={styles.intro}>
      <div className={styles.intro_container}>
        <div className={styles.videoContainer}>
          <iframe
            src="https://player.vimeo.com/video/453482728"
            width="640"
            height="564"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </section>

    <Evaluation />

    <section className={styles.challenge}>
      <div className={styles.challenge_inner}>
        <div className={styles.challenge_txt}>
          <h2>
            BY CHALLENGING YOURSELF, YOU CHALLENGE THE MARK YOU LEAVE ON THE
            WORLD.
          </h2>
          <p>
            Define and create your ethos manifest <span className="orange extra-bold">•em• </span> 
            by getting clear on your core values. Your  <span className="orange extra-bold">•em• </span> 
            is your guide to all things. This is what you will always come back to. If we don’t 
            follow our values we will forever be searching outside ourselves for happiness and fulfillment.{" "}
          </p>
          <p>
            Our <span className="orange extra-bold">•em•</span> allows us 
            to make decisions with clarity and ease, reduces stress, 
            promotes self-empowerment, and gives us the desire to do the 
            work necessary to achieve our goals with a sense of joy.</p>
        </div>
        <div className={styles.challenge_img}>
          <img src={community} loading="lazy" alt="shawna and friends" />
        </div>
      </div>
    </section>

    <TwoSteps />

    <section className={styles.signUp}>
      <div className={styles.signUp_empower}>
        <div className={styles.signUp_empower_inner}>
          <div className={styles.signUp_empower_inner_txt}>
            <h2 className="blue">
              EM• POWERING YOU TO REMEMBER YOUR OWN GREATNESS.
            </h2>
            <p>
            Fitness apps and online workouts are beginning to all look the same. 
            I want to provide you with resources that go beyond focusing only on weight 
            loss, HIIT strength training, and toning. Those are important elements; however, 
            health is holistic. The empower experience is designed to transform the way 
            you approach fitness, movement and mindfulness.
            </p>
          </div>
          <div className={styles.signUp_list}>
            <ul>
              <li>Holistic Health</li>
              <li>Use it anywhere</li>
              <li>Focus on all of yourself</li>
              <li>Meal plan and recipes</li>
              <li>Mindfulness</li>
            </ul>
          </div>
        </div>
      </div>

      <div className={styles.signUp_thrive}>
        <div className={styles.signUp_thrive_inner}>
          <div className={styles.signUp_list}>
            <ul>
              <li>Guided meditations</li>
              <li>Daily workouts</li>
              <li>Stay-at-home workouts</li>
              <li>Healthy eating tips</li>
              <li>Thought coaching</li>
            </ul>
          </div>
          <div className={styles.signUp_thrive_txt}>
            <h2 className="blue">GET READY TO THRIVE, NOT JUST SURVIVE</h2>
            <p>
            Our 7-week program includes em.powered workouts, guided meditations, 
            and health coaching videos that are all accessible from the comfort 
            of your own home. It will be easy to achieve your fitness goals by 
            focusing on daily workouts, healthy eating, and thought coaching without 
            the need for a gym membership.
            </p>
          </div>
        </div>
      </div>
    </section>

    <BuyChallengeBar className={styles.blueTrial} />

    <section className={styles.testimonials}>
      <div className={styles.testimonials_inner}>
        <h2 className="orange">HERE IS HOW YOU COULD FEEL IN 7 WEEKS</h2>
        <div className={styles.testimonials_quotes}>
          <div className={styles.testimonials_quotes_1}>
            <img
              src={grant}
              loading="lazy"
              alt="grant korgan"
              className={styles.testimonials_quotes_img}
            />
            <p>
              “The seven week program showed me the tools that had been right in
              front of my face for decades but I was unable to see them. In a
              short amount of time I had actionable items to execute on, and I
              had clarity for the things that were holding me back. Life is
              simple; we have a way of complicating it and Shawna has a gift of
              showing us the tools to illuminate the simplicity our souls
              already know.”
            </p>
            <p className={styles.testimonials_quotes_name}>- Grant Korgan</p>
          </div>
          <div className={styles.testimonials_quotes_2}>
            <img
              src={toni}
              loading="lazy"
              alt="grant korgan"
              className={styles.testimonials_quotes_img}
            />
            <p>
              "Shawna’s process is incredible, because she takes you on a
              journey. First, you are engaging  in a physical className that
              immediately transports you to a place where you HAVE to be
              present. Then, the thought-coaching comes into play—and your
              presence of mind enables you to fully absorb the tools of
              empowerment that Shawna so genuinely provides."
            </p>
            <p className={styles.testimonials_quotes_name}>- Antonia Polan</p>
          </div>
        </div>
      </div>
    </section>

    <Quote
      quote="My goal - to em•power you to live in your ethos through movement, mindfulness, and my consciously-curated 7-week coaching programs."
      personName="-shawna"
    />
  </Layout>
)

export default challengesPage
